import { Messages } from "../constant/messages/toastMessages";
import { ApiInfo, ToastMessagesType } from "../types";
import { toastMessage } from "./ToastProvider";

export const handleCustomError = (statusCode: number, apiName: ApiInfo) => {
  if (!statusCode || !apiName) {
    return;
  }
  if (statusCode === 200) {
    return;
  }

  let message = "";
  let title = "Error";

  // Context-specific prefixes
  // const contextPrefix = `${contextType}.failure`;
  const contextPrefix = `${apiName}.failure.${statusCode}` as `${string}.failure.${number}`;

  switch (statusCode) {
    // Client-Side
    case 400:
      message = Messages[`${contextPrefix}` as keyof ToastMessagesType]?.message;
      title = Messages[`${contextPrefix}` as keyof ToastMessagesType]?.messageTitle;
      toastMessage.error(title, message);
      break;
    case 401:
      message = Messages[`${contextPrefix}` as keyof ToastMessagesType]?.message;
      title = Messages[`${contextPrefix}` as keyof ToastMessagesType]?.messageTitle;
      toastMessage.error(title, message);
      break;
    case 402:
      message =
        Messages[`${contextPrefix}` as keyof ToastMessagesType]?.message;
      title = Messages[`${contextPrefix}` as keyof ToastMessagesType]?.messageTitle;
      toastMessage.error(title, message);
      break;
    case 403:
      message = Messages[`${contextPrefix}` as keyof ToastMessagesType]?.message;
      title = Messages[`${contextPrefix}` as keyof ToastMessagesType]?.messageTitle;
      toastMessage.error(title, message);
      break;
    case 404:
      message = Messages[`${contextPrefix}` as keyof ToastMessagesType]?.message;
      title = Messages[`${contextPrefix}` as keyof ToastMessagesType]?.messageTitle;
      toastMessage.error(title, message);
      break;

    //   Server-Side Errors
    case 500:
      message = Messages[`${contextPrefix}` as keyof ToastMessagesType]?.message;
      title = Messages[`${contextPrefix}` as keyof ToastMessagesType]?.messageTitle;
      toastMessage.error(title, message);
      break;
    case 501:
      message = Messages[`${contextPrefix}` as keyof ToastMessagesType]?.message;
      title = Messages[`${contextPrefix}` as keyof ToastMessagesType]?.messageTitle;
      toastMessage.error(title, message);
      break;
    case 502:
      message = Messages[`${contextPrefix}` as keyof ToastMessagesType]?.message;
      title = Messages[`${contextPrefix}` as keyof ToastMessagesType]?.messageTitle;
      toastMessage.error(title, message);
      break;
    case 503:
      message = Messages[`${contextPrefix}` as keyof ToastMessagesType]?.message;
      title = Messages[`${contextPrefix}` as keyof ToastMessagesType]?.messageTitle;
      toastMessage.error(title, message);
      break;
    case 504:
      message = Messages[`${contextPrefix}` as keyof ToastMessagesType]?.message;
      title = Messages[`${contextPrefix}` as keyof ToastMessagesType]?.messageTitle;
      toastMessage.error(title, message);
      break;

    default:
      message = Messages["api.error"].message;
      title = Messages["api.error"].messageTitle;
  }

  console.error(`Error (${statusCode}): ${title} - ${message}`);
  // toastMessage.error(title, message);
};